import React, { createContext, useCallback, useContext, useState } from "react";

interface CompanyContextProps {
  refreshCompanyList: boolean;
  triggerRefreshCompanyList: () => void;
}

const CompanyContext = createContext<CompanyContextProps | undefined>(undefined);

export const CompanyProvider = ({ children }: { children: React.ReactNode }) => {
  const [refreshCompanyList, setRefreshCompanyList] = useState(false);

  const triggerRefreshCompanyList = useCallback(() => {
    setRefreshCompanyList(prev => !prev);
  }, []);

  return (
    <CompanyContext.Provider value={{ refreshCompanyList, triggerRefreshCompanyList }}>
      {children}
    </CompanyContext.Provider>
  );
};

export const useCompanyContext = () => {
  const context = useContext(CompanyContext);
  if (!context) {
    throw new Error("useCompanyContext must be used within a CompanyProvider");
  }
  return context;
};
